import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-115335b1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "measure-datatable h-100 w-100" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_n_data_table = _resolveComponent("n-data-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_n_data_table, {
      ref: "datatable",
      size: "small",
      remote: "",
      columns: _ctx.columns,
      bordered: false,
      data: _ctx.data,
      loading: _ctx.loading,
      pagination: _ctx.pagination,
      "onUpdate:sorter": _ctx.handleSorterChange,
      "onUpdate:filters": _ctx.handleFiltersChange,
      "onUpdate:page": _ctx.handlePageChange
    }, null, 8 /* PROPS */, ["columns", "data", "loading", "pagination", "onUpdate:sorter", "onUpdate:filters", "onUpdate:page"])
  ]))
}